import { cn, CopyIconButton, Tooltip } from "@aurem/ui";
import { useMemo } from "react";

export type UUIDProps = {
  value: string | undefined | null;
  chars?: number;
  showCopy?: boolean;
  className?: string;
};

export const UUID = ({
  value,
  chars = 4,
  showCopy = true,
  className,
}: UUIDProps) => {
  const truncatedValue = useMemo(() => {
    if (!value) return "";
    const totalChars = chars * 2 + 3;
    if (value.length <= totalChars) return value;
    const start = value.slice(0, chars);
    const end = value.slice(-chars);
    return `${start}...${end}`;
  }, [value, chars]);

  const isTruncated = value ? value.length > chars * 2 + 3 : false;

  const content = (
    <span
      className={cn(
        "rounded-sm focus-visible:outline-2 focus-visible:outline-primary-500 focus-visible:outline-offset-0",
        className,
      )}
    >
      {truncatedValue}
    </span>
  );

  return (
    <span className="inline-flex items-center gap-1">
      {isTruncated ? <Tooltip content={value}>{content}</Tooltip> : content}
      {showCopy && value && (
        <CopyIconButton copyContent={value} variant="ghost" size="xs" />
      )}
    </span>
  );
};
